import { useRoutes } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import LoginRoutes from "./LoginRoutes";

export const Router = () => {
  return useRoutes([MainRoutes(), LoginRoutes])
};
